import { imageStore } from '../images.js';
import Boundary from './Boundary.js';
import Sprite from '../ui/Sprite.js';

export default class PCLocation extends Boundary {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            position: this.position,
            active: this.active,
            visible: this.visible,
            // screen sprite will be recreated
        };
    }

    static deserialize(data) {
        const pcLocation = new PCLocation({ position: data.position });
        pcLocation.active = data.active;
        pcLocation.visible = data.visible;
        return pcLocation;
    }

    constructor({ position, OSM, GUI }) {
        super({ position, OSM, GUI });
        this.interactionPriority = 10;
        this.active = false;
        this.visible = true;
        this.screen = new Sprite({
            position: this.position,
            image: imageStore.get('img/pc_screen.png'),
            frames: { max: 2, stopAtEnd: false },
            moving: false,
            visible: this.visible,
        });
    }

    canInteract() {
        return true;
    }

    bootUp() {
        const turnOn = () => {
            return {
                animationFunction: () => {
                    this.screen.frames.val = 1;
                },
                speed: 1,
                duration: 8,
            };
        };

        const turnOff = () => {
            return {
                animationFunction: () => {
                    this.screen.frames.val = 0;
                },
                speed: 1,
                duration: 8,
            };
        };
        const activate = {
            animationFunction: () => {
                this.active = true;
            },
            speed: 1,
            duration: 1,
        };
        this.screen.animationQueue.push(turnOn());
        this.screen.animationQueue.push(turnOff());
        this.screen.animationQueue.push(turnOn());
        this.screen.animationQueue.push(turnOff());
        this.screen.animationQueue.push(turnOn());
        this.screen.animationQueue.push(activate);
        this.screen.performAnimations();
    }

    draw() {
        this.screen.position = this.effectivePosition();
        if (this.screen.animationQueue.length === 0) {
            this.screen.frames.val = 0;
            if (this.active) {
                this.screen.frames.val = 1;
            }
        }

        this.screen.draw();
    }
}
